import { PB_TYPE_BANNER } from './constants';

const checkBannerInsertionSet = items => {
  if (items) {
    // do not include if insertionType is set as will have new settings
    const [bannerToInject] = items.filter(
      ({ type, settings: { interval = '', insertionType } }) =>
        !insertionType && type === PB_TYPE_BANNER && interval
    );

    if (bannerToInject) return bannerToInject;
  }

  return null;
};

export default checkBannerInsertionSet;
